import { render, staticRenderFns } from "./BirthdayList.vue?vue&type=template&id=46231783"
import script from "./BirthdayList.vue?vue&type=script&lang=js"
export * from "./BirthdayList.vue?vue&type=script&lang=js"
import style0 from "./BirthdayList.vue?vue&type=style&index=0&id=46231783&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports